<template>
    <BaseForm>
        <template #fields>
            <PresetTextField
                :value="values.companyGroup"
                :presets="COMPANY_GROUP_PRESETS"
                :label="$t('company-group')"
                :error-messages="errors.companyGroup"
                @input="setFieldValue('companyGroup', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('companyGroup', true)"
            />
            <TextField
                :value="values.businessDomain"
                :label="$t('business-domain')"
                :error-messages="errors.businessDomain"
                @input="setFieldValue('businessDomain', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('businessDomain', true)"
            />
            <TextField
                :value="values.department"
                :label="$t('department')"
                :error-messages="errors.department"
                @input="setFieldValue('department', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('department', true)"
            />
            <TextAreaField
                :value="values.organisationalChanges"
                :label="$t('organisational-changes')"
                :error-messages="errors.organisationalChanges"
                :max-length="EventSeriesOrganisation.shape.organisationalChanges.maxLength ?? undefined"
                @input="setFieldValue('organisationalChanges', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('organisationalChanges', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { COMPANY_GROUP_PRESETS } from '@/components/Form/defaults';
import PresetTextField from '@/components/Form/PresetTextField.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesOrganisation } from '../schemas';

const props = defineProps<{ seriesId: string }>();
const seriesId = computed(() => props.seriesId);
const { series, updateEventSeries } = useEventSeriesInjection();

const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    EventSeriesOrganisation,
    computed(() => ({
        companyGroup: series.value?.companyGroup ?? '',
        businessDomain: series.value?.businessDomain ?? '',
        department: series.value?.department ?? '',
        organisationalChanges: series.value?.organisationalChanges ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateEventSeries({ id: seriesId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
